export function shortName(accName) {
    // eventually return something short, w/ accName
    if (accName === undefined) return;
    let words = accName.split(/[ ,s]+/);
    if (words.length <= 3) {
        return capFirstLetter(accName);
    }
     let s = words[0] + words[1] + " ... " + words[words.length - 1];
    return capFirstLetter(s);

}

export function capFirstLetter(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}